import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Users, Building2, Target, Users2, GraduationCap } from 'lucide-react';
import StudentPopup from './StudentPopup';
import './Hero.css';

const Hero: React.FC = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <motion.div
            className="hero-text"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <motion.h1
              className="hero-title"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              Finding, Connecting, Building Success
            </motion.h1>
            
            <motion.p
              className="hero-subtitle"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              Future Tech HR Services Private Limited - Your trusted recruitment partner 
              since 2013. We specialize in matching human potential & talent through 
              integrated tech-based solutions to the jobs seeking them.
            </motion.p>
            
            <motion.div
              className="hero-actions"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
            >
              <button 
                className="btn btn-primary hero-btn"
                onClick={() => setIsPopupOpen(true)}
              >
                <Users2 size={18} />
                Get Started
              </button>
            </motion.div>
          </motion.div>

          <motion.div
            className="hero-visual"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <div className="hero-image">
              <div className="floating-card">
                <Users size={32} />
                <span>Talent Acquisition</span>
              </div>
              <div className="floating-card">
                <Building2 size={32} />
                <span>Corporate Solutions</span>
              </div>
              <div className="floating-card">
                <Target size={32} />
                <span>Perfect Matching</span>
              </div>
              <div className="floating-card">
                <Users2 size={32} />
                <span>Partnership Network</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Popup Component */}
      <StudentPopup 
        isOpen={isPopupOpen} 
        onClose={() => setIsPopupOpen(false)} 
      />
    </section>
  );
};

export default Hero;
